export function formatNumber(
  value: string | number | null,
  {
    type,
    locale,
    currency,
  }: {
    type: 'currency' | 'percent' | 'number';
    locale: string;
    currency: string;
  }
) {
  if (value === null) return null;

  if (type === 'currency') {
    return value.toLocaleString(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
  if (type === 'percent') {
    return value.toLocaleString(locale, {
      style: 'percent',
      minimumFractionDigits: value <= 1 ? 2 : 0,
      maximumFractionDigits: value <= 1 ? 2 : 0,
    });
  }
  if (type === 'number') {
    return value.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
  return value.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

// export function getChartLabel(
//   date: string,
//   grouping: 'week' | 'month' | 'day'
// ) {
//   const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
//
//   if (grouping === 'week') {
//     return `${format(parsedDate, 'MMM')} - week ${getWeek(parsedDate)}`;
//   }
//
//   if (grouping === 'month') {
//     return `${format(parsedDate, 'MMM')}`;
//   }
//
//   return `${format(parsedDate, 'MMM')} - ${format(parsedDate, 'dd')}`;
// }
